import React, { useContext } from 'react';
import { Dropdown } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { dashboardRoutes } from 'routes/siteMaps';
import AppContext from 'context/Context';
import { useAuth } from 'context/AuthWizardContext';

const NavbarTopDropDownMenus = () => {
  const { config: { navbarCollapsed, showBurgerMenu }, setConfig } = useContext(AppContext);
  const { user } = useAuth();
  
  const handleDropdownItemClick = () => {
    if (navbarCollapsed) {
      setConfig('navbarCollapsed', !navbarCollapsed);
    }
    if (showBurgerMenu) {
      setConfig('showBurgerMenu', !showBurgerMenu);
    }
  };

  return (
    <>
      {dashboardRoutes.children[0].children
        .filter(route => {
          // Eğer kullanıcı ID'si 96 ise tüm route'ları göster, aksi takdirde Admin Panel'i gizle
          if (user.customerId === '96') {
            return true; // Tüm route'ları göster
          } else {
            return route.name !== "ADMIN PANEL" && route.name !== "MÜŞTERİ YÖNETİMİ"; // Diğer kullanıcılar için Admin Panel'i gizle
          }
        })
        .map(route => {
          const dynamicTo = route.to.includes(':id')
            ? route.to.replace(':id', user.customerId) // Dinamik id ile değiştirme
            : route.to;

          return (
            <Dropdown.Item
              key={route.name}
              as={Link}
              className={route.active ? 'link-600 text-white' : 'text-500 text-white'}
              to={dynamicTo}
              onClick={handleDropdownItemClick}
              style={{ marginLeft: 20, marginTop: 8, color: 'white', fontWeight: 'bold' }}
            >
              {route.name}
            </Dropdown.Item>
          );
        })}
    </>
  );
};

export default NavbarTopDropDownMenus;
